import type { CallSection, Nudge } from "@repo/app-types/entities/liveCoaching";
import type { FC } from "react";
import { NudgeWidget } from "./nudgeWidget.js";
import { ProgressWidget } from "./progressWidget.js";
import { TalkRatioWidget } from "./talkRatioWidget.js";

export interface CoachingContentProps {
  callTimeSeconds: number;
  agentTalkRatio: number | undefined;
  activeNudge: Nudge | undefined;
  callStages: readonly CallSection[];
}

const TALK_RATIO_STABILIZED_AFTER_SECONDS = 120;

export const CoachingContent: FC<CoachingContentProps> = (props) => {
  // ...

  return (
    <div className="h-0 flex-auto overflow-y-auto px-4 py-3">
      <NudgeWidget activeNudge={props.activeNudge} />

      {props.agentTalkRatio !== undefined ? (
        <div className="mb-3 border-b border-slate-100 pb-3">
          <p className="mb-2 text-[10px] font-semibold text-slate-400">
            Talk ratio
          </p>
          <TalkRatioWidget
            agentTalkRatio={props.agentTalkRatio}
            isTalkRatioStabilized={
              props.callTimeSeconds >= TALK_RATIO_STABILIZED_AFTER_SECONDS
            }
          />
        </div>
      ) : null}

      <ProgressWidget sections={props.callStages} />
    </div>
  );
};
